export const i18n = {
	autoSuggestThreeOrMoreChars: {
		en: 'Please enter 3 or more characters',
		es: 'Ingrese 3 o más caracteres',
	},
	browse: {
		en: 'Browse',
		es: 'Navegar por letra inicial',
	},
	containsRadioLabel: {
		en: 'Contains',
		es: 'Contiene',
	},
	errorPageText: {
		en: 'An error occurred. Please try again later.',
		es: 'Se produjo un error. Por favor, vuelva a intentar más tarde.',
	},
	moreInformation: {
		en: 'More Information',
		es: 'Más información',
	},
	noMatchingTextSearch: {
		en: 'No matches were found for the word or phrase you entered. Please check your spelling, and try searching again. You can also type the first few letters of your word or phrase, or click a letter in the alphabet and browse through the list of terms that begin with that letter.',
		es: 'No se encontraron resultados para lo que usted busca. Revise si escribió correctamente e inténtelo de nuevo. También puede escribir las primeras letras de la palabra o frase que busca o hacer clic en la letra del alfabeto y revisar la lista de términos que empiezan con esa letra.',
	},
	noMatchingExpand: {
		en: 'No matches were found for your selected letter. Please try a new search, or click a different letter in the alphabet and browse through the list of terms that begin with that letter.',
		es: 'No hay resultados para su búsqueda. Inicie una nueva búsqueda o haga clic en otra letra del alfabeto para consultar términos que empiecen con esa letra.',
	},
	pageNotFoundTitle: {
		en: 'Page Not Found',
		es: 'No se encontró la página',
	},
	search: {
		en: 'Search',
		es: 'Buscar',
	},
	searchPlaceholderText: {
		en: 'Enter keywords or phrases',
		es: 'Escribir frase o palabra',
	},
	startsWithRadioLabel: {
		en: 'Starts with',
		es: 'Empieza con',
	},
	termListTitle: {
		en: 'results found for',
		es: 'resultados de',
	},
	termListTitleSingleResult: {
		en: 'result found for',
		es: 'resultado de',
	},
	definitionOf: {
		en: 'Definition of',
		es: 'Definición de',
	},
};
